<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
import { ref, computed } from "vue";
import { trackSwiperEvents } from "@/analyticsHelper";
import { buildApiUrlBasedOnCollection } from "@/helpers/apiHelper";

SwiperCore.use([Navigation]);

const jobsCollection = ref([]);

const props = defineProps({
    locale: {
        type: String,
        required: true,
    },
});

const urlParameters = [
    {
        key: "fields",
        value: "title,url,hero_image,small_description,period,period_short,country,salery,category,duration,job_duration",
    },
];

fetch(buildApiUrlBasedOnCollection("job", urlParameters, props.locale)).then((result) => {
    result.json().then((data) => {
        jobsCollection.value = data.data;
    });
});
</script>
<template>
    <swiper
        :loop="true"
        :slides-per-view="1"
        :breakpoints="{
            '1024': {
                slidesPerView: 2,
            },
        }"
        :navigation="{
            prevEl: '.slider-prev',
            nextEl: '.slider-next',
        }"
        data-slide-name="EXPERIENCE_SHOWCASE"
        @swiper="trackSwiperEvents"
    >
        <swiper-slide
            v-for="(slide, slideIndex) in jobsCollection"
            :key="slideIndex"
            v-slot="{ isActive }"
            class="w-full aspect-square"
        >
            <a :href="slide.url" :title="slide.title" class="block group">
                <ul v-if="slide.requirements_list" class="hidden">
                    <li v-for="(requirement, requirementIndex) in slide.requirements_list" :key="requirementIndex">
                        <span v-text="requirement.text"></span>
                    </li>
                </ul>
                <ul v-if="slide.skills" class="hidden">
                    <li v-for="(skills, skillsIndex) in slide.skills" :key="skillsIndex">
                        <span v-text="skills"></span>
                    </li>
                </ul>

                <div class="aspect-square w-full">
                    <div class="w-full h-full overflow-hidden relative">
                        <div
                            v-if="isActive"
                            class="absolute z-10 w-full h-full flex flex-col justify-end items-end p-3 md:p-5 xl:p-10"
                        >
                            <div class="mr-auto">
                                <h3
                                    class="font-heading md:text-xl lg:text-2xl xl:text-3xl text-white mb-5 uppercase"
                                    v-text="slide.title"
                                ></h3>
                                <div class="grid grid-cols-1 gap-y-3 2xl:gap-y-5">
                                    <p class="font-semibold text-white" v-text="slide.small_description"></p>
                                    <button
                                        class="px-5 py-2 inline-flex items-center border-2 border-white bg-transparant text-white flex-grow-0 space-x-3 font-bold transition duration-300 ease-in-out mb-3 md:mb-0 w-max-w justify-center group-hover:bg-white group-hover:text-black col-span-1 focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
                                    >
                                        <!-- ToDo: vertalen -->
                                        <span>Lees meer</span><i class="fa-light fa-eyes"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <img
                            v-if="slide.hero_image"
                            class="w-full h-full object-cover"
                            :src="slide.hero_image.permalink"
                            :alt="slide.title"
                        />
                    </div>
                </div>
            </a>
        </swiper-slide>
        <div class="flex justify-center md:justify-start pt-5 space-x-3">
            <button class="slider-prev p-3 hover:text-orange">
                <i class="fa-regular fa-long-arrow-left text-2xl"></i>
            </button>
            <button class="slider-next p-3 hover:text-orange">
                <i class="fa-regular fa-long-arrow-right text-2xl"></i>
            </button>
        </div>
    </swiper>
</template>
